import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default function WeekNumber({ date, onClickWeekNumber, weekNumber, checkedWeekNumbers, disabledWeekNumbers, includeWeeksFromRange }) {
    const props = {
        className: 'react-calendar__tile',
        style: { flexGrow: 1 },
    };

    let isWeekStartDateOutOfRange = true
    if (includeWeeksFromRange) {
        isWeekStartDateOutOfRange = moment(date).isBetween(moment(includeWeeksFromRange.startDate), moment(includeWeeksFromRange.endDate), null, '[]')
    }

    const children = <span>{weekNumber}</span>;

    return onClickWeekNumber ? (
        <label style={{marginTop:'7px'}}>
            <input
                type="checkbox"
                disabled={disabledWeekNumbers?.indexOf(parseInt(weekNumber)) >= 0 || !isWeekStartDateOutOfRange}
                checked={checkedWeekNumbers && checkedWeekNumbers.indexOf(parseInt(weekNumber)) >= 0}
                onChange={() => onClickWeekNumber(weekNumber, date)}
            />
            &nbsp;
            {children}
        </label>
    ) : (
        <div {...props}>{children}</div>
    );
}

WeekNumber.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    onClickWeekNumber: PropTypes.func,
    weekNumber: PropTypes.node.isRequired,
    checkedWeekNumbers: PropTypes.array,
};
